import { Link } from 'react-router-dom';
import type { ComprobanteResumen } from '../api';
import {
  fechaArgentina,
  formateaMoneda,
  nombreDeComprobante,
  numeroFormateado,
  receptorLegible,
} from './dominio';

/**
 * Las filas del listado (KAN-146).
 *
 * # LO QUE ESTA TABLA NO HACE
 *
 * 1. **No reordena.** Llegan del más reciente al más viejo (`cbte_fecha DESC,
 *    id DESC`) y así se muestran. Ordenar por número en el cliente daría una
 *    lista que parece rota: **la numeración no arranca en 1 y puede tener
 *    huecos** —la primera Factura A de este proyecto fue la N° 15— y además el
 *    orden solo valdría dentro de la página que se está viendo.
 * 2. **No marca los huecos.** Un salto entre dos números no es un error: puede
 *    ser un comprobante emitido antes de este servicio. Lo que sí sabe decir si
 *    falta algo es la reconciliación (KAN-89), que compara contra ARCA.
 * 3. **No suma nada.** El total del período lo agrega la base; ver
 *    `ResumenDelPeriodo`.
 * 4. **No tiene ninguna acción que escriba.** El único enlace de cada fila
 *    lleva al detalle. Un comprobante fiscal no se borra ni se reemite desde un
 *    listado: se corrige con una nota de crédito, que es una emisión nueva.
 */
export function TablaDeComprobantes({ filas }: { filas: readonly ComprobanteResumen[] }) {
  return (
    <table>
      <caption className="nota">
        Del más reciente al más viejo. Los números pueden tener saltos: la numeración la lleva
        ARCA y no arranca en 1.
      </caption>
      <thead>
        <tr>
          <th scope="col">Comprobante</th>
          <th scope="col">Fecha</th>
          <th scope="col">Receptor</th>
          <th scope="col">CAE</th>
          <th scope="col">Vto. CAE</th>
          <th scope="col">Neto</th>
          <th scope="col">IVA</th>
          <th scope="col">Total</th>
        </tr>
      </thead>
      <tbody>
        {filas.map((fila) => (
          <tr key={fila.id}>
            <td>
              {/* El enlace usa el id INTERNO, no el número de comprobante: el
                  número se repite entre puntos de venta y entre tipos. */}
              <Link to={`/comprobantes/${fila.id}`}>
                {nombreDeComprobante(fila.tipo, fila.letra)}{' '}
                {numeroFormateado(fila.puntoVenta, fila.numero)}
              </Link>
            </td>
            <td>{fechaArgentina(fila.fecha)}</td>
            <td>{receptorLegible(fila.docTipo, fila.docNro)}</td>
            <td className="cae">{fila.cae}</td>
            <td>{fechaArgentina(fila.caeVencimiento)}</td>
            <td className="importe">{formateaMoneda(fila.neto)}</td>
            <td className="importe">{formateaMoneda(fila.iva)}</td>
            <td className="importe">
              <strong>{formateaMoneda(fila.total)}</strong>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
